export default {
    parts: ['header', 'dialog'],
    baseStyle: {
        header: {
            fontSize: '1.5rem',
            fontWeight: 'black',
            lineHeight: '1.5rem',
            letterSpacing: '-0.025em',
            color: 'blue.900',
            pt: 6,
            pb: 1,
        },
        dialog: {
            borderWidth: 1,
            borderColor: 'gray.500',
            rounded: 6,
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9hcGV4LW9ubGluZS9jb21wb25lbnQtbGlicmFyeS90aGVtZS9jb21wb25lbnRzL21vZGFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGVBQWU7SUFDYixLQUFLLEVBQUUsQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDO0lBQzNCLFNBQVMsRUFBRTtRQUNULE1BQU0sRUFBRTtZQUNOLFFBQVEsRUFBRSxRQUFRO1lBQ2xCLFVBQVUsRUFBRSxPQUFPO1lBQ25CLFVBQVUsRUFBRSxRQUFRO1lBQ3BCLGFBQWEsRUFBRSxVQUFVO1lBQ3pCLEtBQUssRUFBRSxVQUFVO1lBQ2pCLEVBQUUsRUFBRSxDQUFDO1lBQ0wsRUFBRSxFQUFFLENBQUM7U0FDTjtRQUNELE1BQU0sRUFBRTtZQUNOLFdBQVcsRUFBRSxDQUFDO1lBQ2QsV0FBVyxFQUFFLFVBQVU7WUFDdkIsT0FBTyxFQUFFLENBQUM7U0FDWDtLQUNGO0NBQ0YsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgcGFydHM6IFsnaGVhZGVyJywgJ2RpYWxvZyddLFxuICBiYXNlU3R5bGU6IHtcbiAgICBoZWFkZXI6IHtcbiAgICAgIGZvbnRTaXplOiAnMS41cmVtJyxcbiAgICAgIGZvbnRXZWlnaHQ6ICdibGFjaycsXG4gICAgICBsaW5lSGVpZ2h0OiAnMS41cmVtJyxcbiAgICAgIGxldHRlclNwYWNpbmc6ICctMC4wMjVlbScsXG4gICAgICBjb2xvcjogJ2JsdWUuOTAwJyxcbiAgICAgIHB0OiA2LFxuICAgICAgcGI6IDEsXG4gICAgfSxcbiAgICBkaWFsb2c6IHtcbiAgICAgIGJvcmRlcldpZHRoOiAxLFxuICAgICAgYm9yZGVyQ29sb3I6ICdncmF5LjUwMCcsXG4gICAgICByb3VuZGVkOiA2LFxuICAgIH0sXG4gIH0sXG59XG4iXX0=